import { useEffect } from 'react';

const SCRIPT_ID = 'structured-data-barbershop';

const StructuredData = ({ settings }) => {
    useEffect(() => {
        // Só gera os dados estruturados se as informações essenciais existirem
        if (!settings || !settings.siteName || !settings.streetAddress || !settings.addressLocality) {
            return;
        }

        const structuredData = {
            "@context": "https://schema.org",
            "@type": "BarberShop", // Define o tipo de negócio como Barbearia
            "name": settings.siteName,
            "image": settings.logoUrl || '',
            "address": {
                "@type": "PostalAddress",
                "streetAddress": settings.streetAddress,
                "addressLocality": settings.addressLocality,
                "postalCode": settings.postalCode,
                "addressCountry": "BR" // Definido como Brasil
            },
            "telephone": settings.telephone,
            "url": window.location.href // Usa a URL atual do site
        };

        let script = document.getElementById(SCRIPT_ID);
        if (!script) {
            script = document.createElement('script');
            script.id = SCRIPT_ID;
            script.type = 'application/ld+json';
            document.head.appendChild(script);
        }
        script.textContent = JSON.stringify(structuredData);

        return () => {
            script?.remove();
        };
    }, [settings]);

    return null;
};

export default StructuredData;
